import React, {useContext, useState, useEffect} from 'react';
import {Button, TextField, Typography, Divider} from '@mui/material';
import {ApplicationContext} from '../context/ApplicationContext';
import {verify2FA} from '../services/login.service';
import {CircularProgress} from "@mui/material";
import {useLocation} from 'react-router-dom';
import config from "../config";
import './Login.scss';

const Verify2FAPage = (props) => {
    const AppContext = useContext(ApplicationContext);
    const location = useLocation();
    const [code, setCode] = useState('');
    const [isWaitingOnServer, setIsWaitingOnServer] = useState(false);
    const [username, setUsername] = useState('');

    useEffect(() => {
        // Get username from location state or query params
        const stateUsername = location?.state?.username;
        const urlParams = new URLSearchParams(window.location.search);
        const queryUsername = urlParams.get('username');
        
        const user = stateUsername || queryUsername;
        if (!user) {
            // No username found, redirect to login
            window.location.replace(`${config.uiBaseUrl}/`);
            return;
        }
        setUsername(user);
    }, [location]);

    const submitForm = (username, code) => {
        setIsWaitingOnServer(true);
        verify2FA(username, code)
            .then((reply) => {
                const destination_page = `${config.uiBaseUrl}/instantAnalytics`
                window.location.replace(destination_page);
                setIsWaitingOnServer(false);
            })
            .catch((err) => {
                console.log(err);
                AppContext.handleError('Invalid verification code. Please try again.');
                setIsWaitingOnServer(false);
                setCode(''); // Clear the code field
            });
    };

    const handleKeyDown = (e) => {
        if (e.key === 'Enter' && code && code.length === 6 && !isWaitingOnServer) {
            submitForm(username, code);
        }
    };

    const handleCodeChange = (e) => {
        // Only allow numeric input and limit to 6 digits
        const value = e.target.value.replace(/\D/g, '').slice(0, 6);
        setCode(value);
    };

    if (!username) {
        return (
            <div className="login-container">
                <div className="login-card loading-state">
                    <CircularProgress size={48} style={{color: '#ffffff', marginBottom: '24px'}}/>
                    <Typography variant="h6" className="primary-font" style={{fontWeight: 500}}>
                        Loading...
                    </Typography>
                </div>
            </div>
        );
    }

    if (isWaitingOnServer) {
        return (
            <div className="login-container">
                <div className="login-card loading-state">
                    <CircularProgress size={48} style={{color: '#ffffff', marginBottom: '24px'}}/>
                    <Typography variant="h6" className="primary-font" style={{fontWeight: 500}}>
                        Verifying...
                    </Typography>
                </div>
            </div>
        )
    }

    return (
        <div className="login-container">
            <div className="login-bg-orbs" aria-hidden="true">
                <div className="orb orb-1" />
                <div className="orb orb-2" />
                <div className="orb orb-3" />
                <div className="orb orb-4" />
            </div>

            <div className="login-card">
                <div className="login-header">
                    <Typography
                        variant="h3"
                        className="login-title"
                        style={{fontFamily: 'Cookie, cursive', fontSize: '48px', marginBottom: '4px'}}
                    >
                        Verdantime
                    </Typography>
                    <div className="login-accent-bar"/>
                    <Typography variant="body2" className="secondary-font" style={{marginTop: '16px', marginBottom: 0}}>
                        Enter the 6-digit code from your authenticator app
                    </Typography>
                </div>

                <div className="login-form">
                    <TextField
                        name="totp_code"
                        type="text"
                        inputMode="numeric"
                        onChange={handleCodeChange}
                        onKeyDown={handleKeyDown}
                        label="Verification Code" 
                        variant="outlined"
                        fullWidth
                        className="login-input"
                        autoComplete="one-time-code"
                        autoFocus
                        value={code}
                        inputProps={{
                            maxLength: 6,
                            style: { 
                                textAlign: 'center',
                                fontSize: '24px',
                                letterSpacing: '8px',
                                fontFamily: 'monospace'
                            }
                        }}
                        placeholder="000000"
                    />

                    <Button 
                        className="login-button primary-font"
                        onClick={() => submitForm(username, code)} 
                        disabled={isWaitingOnServer || !code || code.length !== 6}
                        variant="contained"
                        fullWidth
                        size="large"
                        style={{marginTop: '32px'}}
                    >
                        Verify
                    </Button>
                </div>
            </div>
        </div>
    );
}

export default Verify2FAPage;

